import React from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { StyledToastContainer } from './ToastProviderStyles';

const ToastProvider = () => <StyledToastContainer />;

export default ToastProvider;
